import { FC } from 'react';

import { TeamScore } from '../../common/TeamScore';
import { StatusType, EventParticipantType } from '../../../../../../packages/types';
import { EventContainer, EventStatus } from '../../common';
import BettingRow from '../../common/BettingRow';
import SelectionModel from '@mediaplatform/sportal365-odds-utils/types/models/selection.model';

interface ITwoTeamEventProps {
  dateTime: {
    date: string;
    time: string;
  };
  statusType: StatusType;
  statusText: string | null;
  firstTeam: EventParticipantType;
  secondTeam: EventParticipantType;
  eventLink?: string;
  urlTarget?: string;
  competitionLogo: string;
  topEventsSelected?: boolean;
  selections: SelectionModel[];
  displayOdds: boolean;
  handleClick?: (link: string) => void;
  handleEventClick: (event: string) => void;
  id: string;
}

const TwoTeamsEvent: FC<ITwoTeamEventProps> = ({
  firstTeam,
  secondTeam,
  statusType,
  statusText,
  dateTime,
  urlTarget,
  eventLink,
  competitionLogo,
  topEventsSelected,
  selections,
  displayOdds,
  handleClick,
  handleEventClick,
  id,
}) => {
  return (
    <EventContainer displayOdds={displayOdds}>
      <a target={urlTarget} href={eventLink} style={{ width: '100%', textDecoration: 'none' }} onClick={() => handleEventClick(id)}>
        <EventStatus
          dateTime={dateTime}
          status={statusType}
          statusText={statusText}
          competitionLogo={competitionLogo}
          topEventsSelected={topEventsSelected}
        />
      </a>
      <a target={urlTarget} href={eventLink} style={{ width: '100%', textDecoration: 'none' }} onClick={() => handleEventClick(id)}>
        <TeamScore team={firstTeam} status={statusType} />
      </a>
      <a target={urlTarget} href={eventLink} style={{ width: '100%', textDecoration: 'none' }} onClick={() => handleEventClick(id)}>
        <TeamScore team={secondTeam} status={statusType} />
      </a>
      {displayOdds && <BettingRow selections={selections} handleClick={handleClick} />}
    </EventContainer>
  );
};

export default TwoTeamsEvent;
